import { scrollToFooter } from "../../js/utils/scrollToFooter";

export default function ResourcesLink({
  className = "resources-link",
  tour = "nav-resources",
  label = "Information & Resources",
}) {
  return (
    <button type="button" className={className} data-tour={tour} onClick={scrollToFooter}>
      {label}
    </button>
  );
}
